module.exports = __webpack_public_path__ + "media/icons/share_w-abc6423c.svg";